import React from 'react';
import PropTypes from 'prop-types';

import moTheme from '@ecp/common/src/style/theme/mo';
import { FlexBox } from '@ecp/common/src/layouts/flex/styled';
import { TextBox } from '@ecp/common/src/text/TextBox';

const TimerAdornment = ({ minutes, seconds }) => {
  return (
    <FlexBox
      style={{
        justifyContent: 'flex-end',
        width: '40px',
        alignItems: 'center',
        height: '28px',
        padding: '7px 0',
      }}
    >
      <TextBox
        style={{
          fontSize: '11px',
          fontWeight: moTheme.font.weight.demiLight,
          color: moTheme.color.error1,
          fontVariantNumeric: 'tabular-nums',
        }}
      >
        {minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}
      </TextBox>
    </FlexBox>
  );
};

TimerAdornment.propTypes = {
  minutes: PropTypes.number,
  seconds: PropTypes.number,
};

export default TimerAdornment;